import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { URIEncrypt } from './enum';

function usePagesTitle() {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        const titleArray = path.split("/")
        const len = titleArray.length

        let AppTitle = ""
      
        

        if (len > 1) {
            if (titleArray[len - 1] == 'create-entry')
                AppTitle += titleArray[len - 2] + " Entry" 
           
            else
                AppTitle += titleArray[len - 1] 
        }
        if (AppTitle == "")
            AppTitle = 'POS | Integrated It Solution'

        document.title = AppTitle.replace(/\b\w/g, char => char.toUpperCase()) +" | Integrated It Solution ";
    }, [location]);
}

export default usePagesTitle;
